import { Link } from "react-router-dom";
import "./styles/ClientExperienceShell.css";
import "../styles/ClientTheme.css";

function buildBackgroundImage(backgroundGifUrl) {
  const layers = ["linear-gradient(90deg, rgba(8, 8, 8, 0.76) 0%, rgba(8, 8, 8, 0.38) 42%, rgba(8, 8, 8, 0.08) 100%)"];

  if (backgroundGifUrl) {
    layers.unshift(`url("${backgroundGifUrl}")`);
  }

  return layers.join(", ");
}

function ClientExperienceShell({ backgroundGifUrl, className = "", children }) {
  return (
    <main
      className={["client-flow", className].filter(Boolean).join(" ")}
      style={{
        backgroundImage: buildBackgroundImage(backgroundGifUrl),
        backgroundPosition: "64% center",
      }}
    >
      <header className="client-site-header">
        <Link className="client-site-header-link" to="/">
          Yukon the barber
        </Link>
      </header>
      <div className="client-flow-content">{children}</div>
    </main>
  );
}

export default ClientExperienceShell;
